import {Component, inject, OnInit} from '@angular/core';
import {DialogRef} from '@angular/cdk/dialog';
import {RouterLink} from '@angular/router';
import {NgIconComponent, provideIcons} from '@ng-icons/core';
import {tablerRoute} from '@ng-icons/tabler-icons';
import {
  heroCalendarDays,
  heroCog6Tooth,
  heroHome,
  heroListBullet,
  heroMap,
  heroXMark,
  heroStar,
} from '@ng-icons/heroicons/outline';
import {NgOptimizedImage} from '@angular/common';

const CLOSE_ANIMATION_DURATION_MS = 300;

@Component({
  selector: 'app-menu',
  standalone: true,
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  imports: [RouterLink, NgIconComponent, NgOptimizedImage],
  viewProviders: [provideIcons({heroHome, heroMap, heroCalendarDays, heroListBullet, heroCog6Tooth, heroXMark, tablerRoute, heroStar})]
})
export class MenuComponent implements OnInit {
  private _dialogRef = inject(DialogRef<void>);
  protected visible = false;

  constructor() {
    this._dialogRef.overlayRef.backdropClick().subscribe(() => this.close());
    this._dialogRef.overlayRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  ngOnInit() {
    requestAnimationFrame(() => this.visible = true);
  }

  protected close() {
    if (!this.visible) {
      return;
    }
    this.visible = false;
    setTimeout(() => this._dialogRef.close(), CLOSE_ANIMATION_DURATION_MS);
  }
}
